import { render, staticRenderFns } from "./MedecinDetailFcontinueedit.vue?vue&type=template&id=9bae7964&"
import script from "./MedecinDetailFcontinueedit.vue?vue&type=script&lang=js&"
export * from "./MedecinDetailFcontinueedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports